import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

class LoyaltyMatrixSlide {
    id = uuidv4()

    kind = 'LoyaltyMatrixSlide'

    @observable comparisonSurveyIds

    @observable benchmarks

    constructor({
        benchmarks = [],
        comparisonSurveyIds = [],
    }) {
        this.benchmarks = benchmarks
        this.hasBenchmarks = benchmarks.length > 0

        this.comparisonSurveyIds = comparisonSurveyIds
        this.hasComparisons = comparisonSurveyIds.length > 0
    }

    arrayOrUndefined = (arr) => {
        return Array.isArray(arr) && arr.length > 0
            ? arr.filter(({ checked }) => checked).map(({ value }) => capitalize(value))
            : undefined
    }

    toJSON() {
        return {
            kind: this.kind,
            comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
            benchmarks: this.arrayOrUndefined(this.benchmarks.slice()),
        }
    }
}

export default LoyaltyMatrixSlide
